import { useMutation } from '@apollo/client';
import { bodyCompMutations } from '../graphql/mutations';

interface ConfirmBodyCompQCResponse {
  message: string;
  statusCode: number;
}

interface ConfirmBodyCompQCData {
  confirmBodyCompQC: ConfirmBodyCompQCResponse;
}

interface ConfirmBodyCompQCVars {
  studyId: string;
}

export const useConfirmBodyCompQC = (
  studyId: string,
): {
  confirmBodyCompQC: () => Promise<{ data?: ConfirmBodyCompQCData }>;
  loading: boolean;
  error?: any;
} => {
  const [confirmBodyCompQCMutation, { loading, error }] = useMutation<
    ConfirmBodyCompQCData,
    ConfirmBodyCompQCVars
  >(bodyCompMutations.CONFIRM_BODY_COMP_QC);

  const confirmBodyCompQC = (): Promise<{ data?: ConfirmBodyCompQCData }> =>
    confirmBodyCompQCMutation({ variables: { studyId } });

  return {
    confirmBodyCompQC,
    loading,
    error,
  };
};
